import { render, staticRenderFns } from "./DashboardBusinessList.vue?vue&type=template&id=c448b3ea&"
import script from "./DashboardBusinessList.vue?vue&type=script&lang=ts&"
export * from "./DashboardBusinessList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports